export default __webpack_public_path__ + "static/media/logo.045d9828.png";